import { render, staticRenderFns } from "./PacienteFichaCobrancas.vue?vue&type=template&id=4715f2c8&scoped=true"
import script from "./PacienteFichaCobrancas.vue?vue&type=script&lang=js"
export * from "./PacienteFichaCobrancas.vue?vue&type=script&lang=js"
import style0 from "./PacienteFichaCobrancas.vue?vue&type=style&index=0&id=4715f2c8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4715f2c8",
  null
  
)

export default component.exports